module.exports = __webpack_public_path__ + "./fonts/montserrat-latin-300italic.37c74a8d2d0d36a0a2c6e9a37ee15b0c.woff";